export default __webpack_public_path__ + "static/media/11.280b5b05.webp";